var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{style:(_vm.fabStyle),attrs:{"aria-label":"WhatsApp"},on:{"click":_vm.handleClick}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("mdi-whatsapp")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }